import React from 'react';
import PropTypes from 'prop-types';
import { LabelText, Slider, ToggleInput, ToggleLabel } from './SimpleToggle.styles';

const SimpleToggle = ({ onClick, label, isActive }) => {
    return (
        <ToggleLabel>
            <ToggleInput type="checkbox" checked={isActive} onChange={onClick} />
            <Slider />
            {label ? <LabelText isActive={isActive}>{label}</LabelText> : null}
        </ToggleLabel>
    );
};

SimpleToggle.propTypes = {
    onClick: PropTypes.func,
    label: PropTypes.string,
    isActive: PropTypes.bool,
};

SimpleToggle.defaultProps = {
    onClick: undefined,
    label: '',
    isActive: false,
};

export default SimpleToggle;
